export default {
    state: {
        token: localStorage.getItem("tokenAdmin") || "",
        role: localStorage.getItem("role") || ""
    },
    getters: {
        isAuthenticated(state) {
            return state.token !== null && state.token !== "" &&
                state.role !== null && state.role !== ""
                ;
        },
    },
    actions: {
        resetAuthState({commit}) {
            commit('resetState')
        },
    },
    mutations: {
        resetState(state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            localStorage.removeItem("tokenAdmin")
        }
    }
};
